




















import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';

@Component({
    components: {
    },
})

export default class ChooseAddingPaymentMethodOverlay extends Vue {

    public openAddCreditCardOverlay() {
        this.$store.commit(Mutations.SET_CHOOSE_PAYMENT_METHOD_BLOCK_VISIBILITY, false);
        this.$store.commit(Mutations.SET_ADD_NEW_CARD_FORM_VISIBILITY, true);

    }

}
